import React from 'react'

export default function Header(props) {
  return (
   <h1 className={`text-center md:text-start ${props.className}`}>{props.title}</h1>
  )
}
